import { FC } from 'react';

import { OperationType as OperationTypeType } from '../../types';

import styles from './OperationType.module.css';

type Props = {
  type: OperationTypeType;
};

const OperationType: FC<Props> = ({ type }) => (
  <span className={`${styles.root} ${styles[type]}`}>{type}</span>
);

export default OperationType;
